import type React from 'react';
import './Toggle.scss';

export interface ToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  caption?: string;
  /** Renders the switch alone, for use inside an already-clickable row. */
  bare?: boolean;
  disabled?: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
  caption,
  bare = false,
  disabled = false,
}) => {
  const track = (
    <span className={`toggle__track${checked ? ' toggle__track--on' : ''}`}>
      <span className="toggle__knob" />
    </span>
  );

  if (bare) return track;

  return (
    <button
      type="button"
      className="toggle"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      {track}
      <span className="toggle__text">
        <span className="toggle__label">{label}</span>
        {caption && <span className="toggle__caption">{caption}</span>}
      </span>
    </button>
  );
};

export default Toggle;
